import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModule } from '../../ui/ui.module';
import { CardModule } from 'primeng/card';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { RootsEditScheduledActivityComponent } from './roots-edit-scheduled-activity/roots-edit-scheduled-activity.component';
import { EditRootsContactsComponent } from './edit-roots-contacts/edit-roots-contacts.component';
import { EditPartnerNeedComponent } from './edit-partner-need/edit-partner-need.component';
import { EditPartnerEventComponent } from './edit-partner-events/edit-partner-event.component';
import { RootsAddSupporterComponent } from './roots-add-supporter/roots-add-supporter.component';
import { EditPartnerNotesComponent } from './edit-partner-notes/edit-partner-notes.component';
import { AddPartnerGalleryPhotoComponent } from './add-partner-gallery-photo/add-partner-gallery-photo.component';
import { DeletePartnerFileComponent } from './delete-partner-file/delete-partner-file.component';
import { DeletePartnerSupporterComponent } from './delete-partner-supporter/delete-partner-supporter.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextarea } from 'primeng/inputtextarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

@NgModule({
  providers: [ConfirmationService],
  declarations: [
    RootsEditScheduledActivityComponent,
    EditRootsContactsComponent,
    EditPartnerNeedComponent,
    EditPartnerEventComponent,
    RootsAddSupporterComponent,
    EditPartnerNotesComponent,
    AddPartnerGalleryPhotoComponent,
    DeletePartnerFileComponent,
    DeletePartnerSupporterComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    UiModule,
    ReactiveFormsModule,
    DatePickerModule,
    SelectModule,
    MultiSelectModule,
    ButtonModule,
    InputTextModule,
    InputTextarea,
    ConfirmDialogModule
  ],
  exports: []
})
export class RootsNotesModule { }
